const LEGEND_TYPE = {
  CIRCLE: 'CIRCLE',
  RECTANGLE: 'RECTANGLE',
  DASHED_LINE: 'DASHED_LINE',
  SQUARE: 'SQUARE',
  BIG_RECTANGLE: 'BIG_RECTANGLE',
};

export default LEGEND_TYPE;
